import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoReceitaArrecadada: ['administracao'],
    removeRecursoReceitaArrecadada: ['recurso'],
    removeDestinacaoReceitaArrecadada: ['destinacao'],
    removeTipoRecursoReceitaArrecadada: ['tipoRecurso'],
    removeGrauReceitaArrecadada: ['grau'],
    setMostraAplicarFiltroReceitaArrecadada: [],
    limpaFiltroReceitaArrecadada: [],
    aplicarFiltroReceitaArrecadada: ['filtro'],
})

const INITIAL_STATE = {
    administracoes: [],
    recursos: [],
    destinacoes: [],
    tipoRecursos: [],
    grau: '',
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracoes.splice(state.administracoes.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracoes = Array.from(state.administracoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recursos.splice(state.recursos.indexOf(action.recurso), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.recursos = Array.from(state.recursos)
    return { ...state, mostraAplicarFiltro: true }
}

const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacoes.splice(state.destinacoes.indexOf(action.destinacao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.destinacoes = Array.from(state.destinacoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTipoRecurso = (state = INITIAL_STATE, action) => {
    state.tipoRecursos.splice(state.tipoRecursos.indexOf(action.tipoRecurso), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.tipoRecursos = Array.from(state.tipoRecursos)
    return { ...state, mostraAplicarFiltro: true }
}

const removeGrau = (state = INITIAL_STATE, action) => {
    return { ...state, grau: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_RECEITA_ARRECADADA]: removeAdministracao,
    [Types.REMOVE_RECURSO_RECEITA_ARRECADADA]: removeRecurso,
    [Types.REMOVE_DESTINACAO_RECEITA_ARRECADADA]: removeDestinacao,
    [Types.REMOVE_TIPO_RECURSO_RECEITA_ARRECADADA]: removeTipoRecurso,
    [Types.REMOVE_GRAU_RECEITA_ARRECADADA]: removeGrau,
    [Types.SET_MOSTRA_APLICAR_FILTRO_RECEITA_ARRECADADA]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_RECEITA_ARRECADADA]: limpaFiltro,
    [Types.APLICAR_FILTRO_RECEITA_ARRECADADA]: aplicarFiltro,
})
